import React from "react";
import { Button } from "@/components/ui/button";

interface DangerZoneProps {
  onLogout: () => void;
}

export const DangerZone: React.FC<DangerZoneProps> = ({ onLogout }) => {
  return (
    <div className="rounded-xl p-6 border-2 border-destructive bg-card">
      <div className="flex flex-col space-y-6">
        <h2 className="text-xl font-semibold text-destructive">Danger Zone</h2>
        <Button
          variant="outline"
          className="w-fit text-destructive border-destructive hover:bg-destructive hover:text-destructive-foreground"
          onClick={onLogout}
        >
          Logout
        </Button>
      </div>
    </div>
  );
};
